import { gql } from 'graphql-request'

export default gql`
  mutation addQuickAccess($index: Int!, $role: String!, $link_url: String!, $link_title: String!) {
    addQuickAccess(index: $index, role: $role, link_url: $link_url, link_title: $link_title) {
      index
      user {
        id
      }
      role {
        role
      }
      link {
        title
        url {
          path
        }
      }
    }
  }
`
